import React, { useContext, useEffect, useState } from 'react'
import './style/home.css'
import cjt from '../../assets/icon/dright.png'
import more from '../../assets/icon/more.png'
import game from '../../assets/icon/游戏.png'
import mac from '../../assets/icon/mac.png'
import returnTop from '../../assets/icon/returnTop.png'
import Carousels from '../../assembly/Carousel'
import { Link } from 'react-router-dom'
import api from '../../uitil/api'
import { encode } from 'js-base64'
import { CountContext } from '../../App'

export default function Home() {
  const value = useContext(CountContext)
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  //装机必备
  const [necessary, setNecessary] = useState([])
  // 飙升榜
  const [soar, setSoar] = useState([])
  //新游榜
  const [news, setNews] = useState([])
  const [watch, setWatch] = useState(1)

  //请求接口数据
  const security = async (homeApi) => {
    await api.get(`${homeApi}`).then((data) => {
      if (homeApi === 'essential') {
        setNecessary(data)
      } else if (homeApi === 'surge') {
        setSoar(data)
      } else if (homeApi === 'newgame') {
        setNews(data)
      }
    })
  }

  //初始化调用一次
  useEffect(() => {
    security('essential')
    security('surge')
    security('newgame')
  }, [])
  //返回顶部
  const [scrollPosition, setScrollPosition] = useState(0)
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY)
    }
    window.addEventListener('scroll', handleScroll)

    const myElement = document.getElementsByClassName('retuntop')[0]
    if (scrollPosition > 0) {
      myElement.style.display = 'block'
      myElement.classList.remove('move-down')
      myElement.classList.add('move-up')
    } else {
      myElement.classList.remove('move-up')
      myElement.classList.add('move-down')
    }
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [scrollPosition])
  return (
    <>
      <div className="all">
        <Carousels />
        <div className="center">
          <div className="necessary">
            <div className="necess_top">
              <span className="s_one">装机必备</span>
              <div className="hx"></div>
              <Link to="window">
                <span className="s_two">更多</span>
              </Link>
            </div>

            <div className="necess_bottom">
              {necessary.map((item, index) => (
                <div
                  className="list"
                  key={index}
                  onClick={() => {
                    window.open(
                      `/#/home/${item.id}?item=${encode(JSON.stringify(item))}`,
                      '_blank'
                    )
                  }}>
                  <div className="item">
                    <img src={item.icon_url} alt="" />
                    <span className="name">{item.soft_name}</span>
                    <span className="chakan">查看</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="soar">
            <div className="soar_top">
              <span
                onClick={() => {
                  setWatch(1)
                  const hx = document.querySelector('.hxone')
                  hx.style.left = '22px'
                }}>
                飙升榜
              </span>
              <span className="hxone"></span>
              <span
                onClick={() => {
                  setWatch(2)
                  const hx = document.querySelector('.hxone')
                  hx.style.left = '97px'
                }}>
                新游榜
              </span>
            </div>
            <div className="soar_bottom">
              {watch === 1 &&
                soar.map((item, index) => (
                  <div
                    className="list"
                    key={item.id}
                    onClick={() => {
                      window.open(
                        `/#/home/${item.id}?item=${encode(
                          JSON.stringify(item)
                        )}`,
                        '_blank'
                      )
                    }}>
                    <div className="paim">{index + 1}.</div>
                    <div className="item">
                      <img src={item.icon_url} alt="" />
                      <span className="name">{item.soft_name}</span>
                      <span className="chakan">查看</span>
                    </div>
                  </div>
                ))}
              {watch === 2 &&
                news.map((item, index) => (
                  <div
                    className="list"
                    key={item.id}
                    onClick={() => {
                      window.open(
                        `/#/home/${item.id}?item=${encode(
                          JSON.stringify(item)
                        )}`,
                        '_blank'
                      )
                    }}>
                    <div className="paim">{index + 1}.</div>
                    <div className="item">
                      <img src={item.icon_url} alt="" />
                      <span className="name">{item.soft_name}</span>
                      <span className="chakan">查看</span>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        <div className="weekly_list">
          <div className="software_list">
            <div className="title">
              <img src={more} alt="" />
              <span>win软件下载总榜</span>
            </div>
            <ul className="list_item">
              {value.winHot.map((item, index) => (
                <li
                  className="item_li"
                  key={index}
                  onClick={() => {
                    window.open(
                      `/#/window/${item.id}?item=${encode(
                        JSON.stringify(item)
                      )}`,
                      '_blank'
                    )
                  }}>
                  <div className="item_letf">
                    <img className="left_img" src={item.icon_url} alt="" />
                  </div>
                  <div className="item_center">
                    <p className="name">{item.soft_name}</p>
                    <div className="center_bottom">
                      <span>下载:{item.download_count}</span>
                      <span>评论:{item.remark_count}</span>
                    </div>
                  </div>
                  <div className="item_right">
                    <img src={cjt} alt="" />
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="software_list">
            <div className="title">
              <img src={game} alt="" />
              <span>游戏下载总榜</span>
            </div>
            <ul className="list_item">
              {value.gameHot.map((item, index) => (
                <li
                  className="item_li"
                  key={index}
                  onClick={() => {
                    window.open(
                      `/#game/${item.id}?item=${encode(JSON.stringify(item))}`,
                      '_blank'
                    )
                  }}>
                  <div className="item_letf">
                    <img className="left_img" src={item.icon_url} alt="" />
                  </div>
                  <div className="item_center">
                    <p className="name">{item.soft_name}</p>
                    <div className="center_bottom">
                      <span>下载:{item.download_count}</span>
                      <span>评论:{item.remark_count}</span>
                    </div>
                  </div>
                  <div className="item_right">
                    <img src={cjt} alt="" />
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div className="software_list">
            <div className="title">
              <img src={mac} alt="" />
              <span>mac软件下载总榜</span>
            </div>
            <ul className="list_item">
              {value.macHot.map((item, index) => (
                <li
                  className="item_li"
                  key={index}
                  onClick={() => {
                    window.open(
                      `/#mac/${item.id}?item=${encode(JSON.stringify(item))}`,
                      '_blank'
                    )
                  }}>
                  <div className="item_letf">
                    <img className="left_img" src={item.icon_url} alt="" />
                  </div>
                  <div className="item_center">
                    <p className="name">{item.soft_name}</p>
                    <div className="center_bottom">
                      <span>下载:{item.download_count}</span>
                      <span>评论:{item.remark_count}</span>
                    </div>
                  </div>
                  <div className="item_right">
                    <img src={cjt} alt="" />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div
        className="retuntop"
        onClick={() => {
          window.scrollTo(0, 0)
        }}>
        <img src={returnTop} alt="" />
      </div>
    </>
  )
}
